import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterArticle_template} from "./filterArticle_template";

declare var ko: any;

export class config_ai_template extends vnTemplate {

    protected referableBrands: multipleSelector_template;
    protected contentTypesForSummary: multipleSelector_template;
    protected articleTypesForSummary: multipleSelector_template;
    protected contentTypesForFaq: multipleSelector_template;
    protected articleTypesForFaq: multipleSelector_template;
    protected filterDateForCsv: filterDate_template;
    public filterArticle: filterArticle_template;
    protected contentTypesForThread: multipleSelector_template;
    protected articleTypesForThread: multipleSelector_template;
    protected contentTypesForNewsletterPromotion: multipleSelector_template;
    protected articleTypesForNewsletterPromotion: multipleSelector_template;
    protected listingPageTypesForNewsletterPromotion: multipleSelector_template;
    protected initialValues ;
    protected contentTypesForDealsCategoryPromotion: multipleSelector_template;
    protected articleTypesForDealsCategoryPromotion: multipleSelector_template;

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

 protected getTemplateHtml(): string {
    return /*html*/`
    <div class="w-form w-form-large w-ai-config">
        <div class="form-header">
            <h3 class="form-title icon i-ai">Assistant Config</h3>
        </div>

        <div class="form-pagination only-text">
            <button type="button" data-bind="click: () => activeTab('general'), visible: permissions()['config_assistant_general'] && permissions()['config_assistant_general'].write , css: { active: activeTab() === 'general' }">General</button>
            <button type="button" data-bind="click: () => activeTab('website'), visible: permissions()['config_assistant_website'] && permissions()['config_assistant_website'].write , css: { active: activeTab() === 'website' }">Website</button>
            <button type="button" data-bind="click: () => activeTab('emaki'), visible:  permissions()['config_assistant_emaki'] && permissions()['config_assistant_emaki'].write , css: { active: activeTab() === 'emaki' }">Emaki</button>
        </div>

        <!-- General Tab -->
        <div class="ww-form-body" data-bind="visible: activeTab() === 'general' && permissions()['config_assistant_general'] && permissions()['config_assistant_general'].write">
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title parent">Brand Context</strong>

                    <div class="form-group">
                        <label for="brandContext" class="form-label">Website Assistant Brand Context</label>
                        <textarea class="input-text" data-bind="value: brandContext" id="brandContext" style="height:20rem;" maxlength="2000"></textarea>
                    </div>
                    <div class="form-group">
                        <label for="emakiBrandContext" class="form-label">Emaki Assistant Brand Context</label>
                        <textarea class="input-text" data-bind="value: emakiBrandContext" id="emakiBrandContext" style="height:20rem;" maxlength="2000"></textarea>
                    </div>

                    <div class="form-group wide-multi-select">
                        ${this.referableBrands.getHtmlBuild()}
                    </div>

                    <div class="form-group selected w-filters-selected" id="selected_referableBrands">
                    </div>

                </div>
                <div class="form-body">
                    <strong class="form-sub-title parent">Personalities</strong>
                    <div class="form-group">
                        <label for="factualSummaryPersonality" class="form-label">Factual Personality</label>
                        <textarea class="input-text" data-bind="value: factualSummaryPersonality" id="factualSummaryPersonality" style="height:20rem;"  maxlength="2000" ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="satiricalSummaryPersonality" class="form-label">LightHearted Personality</label>
                        <textarea class="input-text" data-bind="value: satiricalSummaryPersonality" id="satiricalSummaryPersonality" style="height:20rem;"  maxlength="2000" ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="simpleSummaryPersonality" class="form-label">Simple Personality</label>
                        <textarea class="input-text" data-bind="value: simpleSummaryPersonality" id="simpleSummaryPersonality" style="height:20rem;"  maxlength="2000"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <!-- Website Tab -->
        <div class="ww-form-body assintant-website" data-bind="visible: activeTab() === 'website' && permissions()['config_assistant_website'] && permissions()['config_assistant_website'].write">
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title parent">Article Summaries</strong>
                    <div class="form-group row">
                        <div>
                            <input type="checkbox" data-bind="checked: factualSummaryAvailable" class="input-checkbox" id="factualSummaryAvailable">
                            <label class="form-label icon i-check" for="factualSummaryAvailable">Enable Factual Summary</label>
                        </div>
                        <div >
                            <input type="checkbox" data-bind="checked: satiricalSummaryAvailable" class="input-checkbox" id="satiricalSummaryAvailable">
                            <label class="form-label icon i-check" for="satiricalSummaryAvailable">Enable LightHearted Summary</label>
                        </div>
                        <div>
                            <input type="checkbox" data-bind="checked: simpleSummaryAvailable" class="input-checkbox" id="simpleSummaryAvailable">
                            <label class="form-label icon i-check" for="simpleSummaryAvailable">Enable Simple Summary</label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div>
                            <input type="checkbox" data-bind="checked: isSummaryOnByDefault" class="input-checkbox" id="isSummaryOnByDefault">
                            <label class="form-label icon i-check" for="isSummaryOnByDefault">On by Default</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div style="display: flex;">
                        <div class="form-group">
                            <legend class="form-legend">Content Types</legend>
                            ${this.contentTypesForSummary.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <legend class="form-legend">Article Types</legend>
                            ${this.articleTypesForSummary.getHtmlBuild()}
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>

                    <div class="form-group">
                        <label for="summaryPrompt" class="form-label">Prompt</label>
                        <textarea class="input-text" data-bind="value: summaryPrompt" id="summaryPrompt" style="height: 20rem;"></textarea>
                    </div>
                </div>
                <div class="form-body">
                    <strong class="form-sub-title parent">Article Thread Summary</strong>
                    <div class="form-group row">
                        <div >
                            <input type="checkbox" data-bind="checked: threadAvailable" class="input-checkbox" id="threadAvailable">
                            <label class="form-label icon i-check" for="threadAvailable">Available For Use</label>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: isThreadOnByDefault" class="input-checkbox" id="isThreadOnByDefault">
                            <label class="form-label icon i-check" for="isThreadOnByDefault">On by Default</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="d-flex">
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Content Types</legend>
                                ${this.contentTypesForThread.getHtmlBuild()}
                                <div style="display: none;" id="selected_threadArticleTypes" class="filters-selected"></div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Article Types</legend>
                                ${this.articleTypesForThread.getHtmlBuild()}
                                <div style="display: none;" id="selected_threadArticleTypes" class="filters-selected"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div>
                            <label for="threadPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: threadPersonality" id="threadPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">Satirical</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: threadBrandContextAvailable" class="input-checkbox" id="threadBrandContextAvailable">
                            <label class="form-label icon i-check" for="threadBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="form-group">
                        <label for="threadPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: threadPrompt" id="threadPrompt" style="height: 20rem;" required></textarea>
                    </div>
                    <!--<div class="form-group">
                        <label for="threadCTAPrompt" class="form-label">CTA Thread Prompt</label>
                        <textarea class="input-text" data-bind="value: threadCTAPrompt" id="threadCTAPrompt" style="height: 20rem;"></textarea>
                    </div>-->
                </div>
                <div class="form-body is-hidden">
                    <strong class="form-sub-title parent">Article FAQ</strong>
                    <div class="form-group row">
                        <div class="form-check-inline" style="width: auto;">
                            <div>
                                <input type="checkbox" data-bind="checked: faqAvailable" class="input-checkbox" id="faqAvailable">
                                <label class="form-label icon i-check" for="faqAvailable">Available For Use</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="d-flex">
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Content Types</legend>
                                ${this.contentTypesForFaq.getHtmlBuild()}
                                <div style="display: none;" id="selected_faqContentTypes" class="filters-selected"></div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Article Types</legend>
                                ${this.articleTypesForFaq.getHtmlBuild()}
                                <div style="display: none;" id="selected_articleTypes" class="filters-selected"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div>
                            <label for="faqPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: faqPersonality" id="faqPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">Satirical</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: faqBrandContextAvailable" class="input-checkbox" id="faqBrandContextAvailable">
                            <label class="form-label icon i-check" for="faqBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="form-group">
                        <label for="faqPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: faqPrompt" id="faqPrompt" style="height: 20rem;" required></textarea>
                    </div>
                </div>
                <div class="form-body">
                    <strong class="form-sub-title parent">Article Quiz</strong>
                    <div class="form-group row">
                        <div>
                            <label for="quizPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: quizPersonality" id="quizPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">Satirical</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: quizBrandContextAvailable" class="input-checkbox" id="quizBrandContextAvailable">
                            <label class="form-label icon i-check" for="quizBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="form-group">
                        <label for="quizPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: quizPrompt" id="quizPrompt" style="height: 20rem;" required></textarea>
                    </div>
                    <!--<div class="form-group">
                        <label for="quizCTAPrompt" class="form-label">CTA Quiz Prompt</label>
                        <textarea class="input-text" data-bind="value: quizCTAPrompt" id="quizCTAPrompt" style="height: 20rem;"></textarea>
                    </div>-->
                </div>
                <div class="form-body">
                    <strong class="form-sub-title parent">Article Poll</strong>
                    <div class="form-group row">
                        <div>
                            <label for="articlePollPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: articlePollPersonality" id="articlePollPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">LightHearted</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: articlePollBrandContextAvailable" class="input-checkbox" id="articlePollBrandContextAvailable">
                            <label class="form-label icon i-check" for="articlePollBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="articlePollPrompt" class="form-label">Prompt</label>
                        <textarea class="input-text" data-bind="value: articlePollPrompt" id="articlePollPrompt" style="height:20rem;"></textarea>
                    </div>
                </div>
                <div class="form-body">
                    <strong class="form-sub-title parent">Article Newsletter Promotion</strong>
                    <div class="form-group row">
                        <div>
                            <input type="checkbox" data-bind="checked: isNewsletterPromotionEnabled" class="input-checkbox" id="newsletterPromotion">
                            <label class="form-label icon i-check" for="newsletterPromotion">Enable Article Newsletter Promotion</label>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: isNewsletterPromotionOnByDefault" class="input-checkbox" id="isNewsletterPromotionOnByDefault">
                            <label class="form-label icon i-check" for="isNewsletterPromotionOnByDefault">On by Default</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="d-flex">
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Content Types</legend>
                                ${this.contentTypesForNewsletterPromotion.getHtmlBuild()}
                                <div style="display: none;" id="selected_newsletterPromotionContentTypes" class="filters-selected"></div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Article Types</legend>
                                ${this.articleTypesForNewsletterPromotion.getHtmlBuild()}
                                <div style="display: none;" id="selected_newsletterPromotionArticleTypes" class="filters-selected"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div>
                            <label for="newsletterPromotionPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: newsletterPromotionPersonality" id="newsletterPromotionPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">Satirical</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: newsletterPromotionBrandContextAvailable" class="input-checkbox" id="newsletterPromotionBrandContextAvailable">
                            <label class="form-label icon i-check" for="newsletterPromotionBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="form-group">
                        <label for="newsletterPromotionPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: newsletterPromotionPrompt" id="newsletterPromotionPrompt" style="height: 20rem;" required></textarea>
                    </div>
                </div>

                <div class="form-body">
                    <strong class="form-sub-title parent">Hub Page Newsletter Promotion</strong>
                    <div class="form-group row">
                        <div>
                            <input type="checkbox" data-bind="checked: isListingPageNewsletterPromotionEnabled" class="input-checkbox" id="listingPageNewsletterPromotion">
                            <label class="form-label icon i-check" for="listingPageNewsletterPromotion">Enable Hub Page Newsletter Promotion</label>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: isListingPageNewsletterPromotionOnByDefault" class="input-checkbox" id="isListingPageNewsletterPromotionOnByDefault">
                            <label class="form-label icon i-check" for="isListingPageNewsletterPromotionOnByDefault">On by Default</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="d-flex">
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Hub Page Types</legend>
                                ${this.listingPageTypesForNewsletterPromotion.getHtmlBuild()}
                                <div style="display: none;" id="selected_listingPageNewsletterPromotionHubpageTypes" class="filters-selected"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div>
                            <label for="listingPageNewsletterPromotionPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: listingPageNewsletterPromotionPersonality" id="listingPageNewsletterPromotionPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">Satirical</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: listingPageNewsletterPromotionBrandContextAvailable" class="input-checkbox" id="listingPageNewsletterPromotionBrandContextAvailable">
                            <label class="form-label icon i-check" for="listingPageNewsletterPromotionBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="form-group">
                        <label for="listingPageNewsletterPromotionPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: listingPageNewsletterPromotionPrompt" id="listingPageNewsletterPromotionPrompt" style="height: 20rem;" required></textarea>
                    </div>
                </div>

                <div class="form-body">
                    <strong class="form-sub-title parent">Deals Category Promotion</strong>
                    <div class="form-group row">
                        <div>
                            <input type="checkbox" data-bind="checked: isDealsCategoryPromotionEnabled" class="input-checkbox" id="dealsCategoryPromotion">
                            <label class="form-label icon i-check" for="dealsCategoryPromotion">Enable Deals Category Promotion</label>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: isDealsCategoryPromotionOnByDefault" class="input-checkbox" id="isDealsCategoryPromotionOnByDefault">
                            <label class="form-label icon i-check" for="isDealsCategoryPromotionOnByDefault">On by Default</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="d-flex">
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Content Types</legend>
                                ${this.contentTypesForDealsCategoryPromotion.getHtmlBuild()}
                                <div style="display: none;" id="selected_dealsCategoryPromotionContentTypes" class="filters-selected"></div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Article Types</legend>
                                ${this.articleTypesForDealsCategoryPromotion.getHtmlBuild()}
                                <div style="display: none;" id="selected_dealsCategoryPromotionArticleTypes" class="filters-selected"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div>
                            <label for="dealsCategoryPromotionPersonality" class="form-label">Personality</label>
                            <select class="input-select" data-bind="value: dealsCategoryPromotionPersonality" id="dealsCategoryPromotionPersonality">
                                <option value="">Select a Personality</option>
                                <option value="simple">Simple</option>
                                <option value="factual">Factual</option>
                                <option value="satirical">Satirical</option>
                            </select>
                        </div>
                        <div style="padding-left: 2rem;">
                            <input type="checkbox" data-bind="checked: dealsCategoryPromotionBrandContextAvailable" class="input-checkbox" id="dealsCategoryPromotionBrandContextAvailable">
                            <label class="form-label icon i-check" for="dealsCategoryPromotionBrandContextAvailable">Brand Context</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div class="form-group">
                        <label for="dealsCategoryPromotionPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: dealsCategoryPromotionPrompt" id="dealsCategoryPromotionPrompt" style="height: 20rem;" required></textarea>
                    </div>
                </div>

            </div>
        </div>

        <!-- Emaki Tab -->
        <div class="ww-form-body" data-bind="visible: activeTab() === 'emaki' &&   permissions()['config_assistant_emaki'] && permissions()['config_assistant_emaki'].write">

                <div class="w-form-body" style=" width: 100%;">


                </div>

                <div class="w-form-body textarea" style=" width: 100%;">

                    <div class="form-body">


                        <div style="display: flex; align-items: center;">
                            <div class="form-group">
                                <input data-bind="checked: assistantFeatureFeedbackEnable" type="checkbox" class="input-checkbox" id="assistantFeatureFeedbackEnableId">
                                <label class="form-label icon i-check" for="assistantFeatureFeedbackEnableId">Enable feedback</label>
                            </div>

                            <div data-bind="css: { 'is-disabled': !assistantFeatureFeedbackEnable() }" style="display: flex;align-items: center; margin-bottom: -2.25rem;">
                                <div class="form-group">
                                    ${this.filterDateForCsv.getHtmlBuild()}
                                </div>


                            </div>

                             <div class="form-group" style="align-items: center;">
                                <button data-bind="click: onDownloadFeedback, css: { 'is-disabled': !assistantFeatureFeedbackEnable() }" class="btn-form icon i-download" style="gap:.5rem;">Export Feedback</button>
                            </div>

                        </div>


                        <div class="form-group">
                            <hr class="form-hr">
                        </div>

                        <div class="form-group inside-label">
                            <label class="form-label" for="idArticle" > Test Article For Config Assistant </label>
                            ${this.filterArticle.getHtmlBuild()}
                        </div>

                        <strong class="form-sub-title parent">Article-Level Prompts</strong>

                        <div class="form-group row">

                            <div class="w-textarea">
                                <!-- <label for="titleDiscoverandOptimizePrompt" class="form-label">Title Prompt</label> -->
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: titleDiscoverandOptimizePromptAvailable" class="input-checkbox" id="titleDiscoverandOptimizePromptAvailable">
                                    <label class="form-label icon i-check" for="titleDiscoverandOptimizePromptAvailable">Enable Title Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: titleDiscoverandOptimizePrompt, disable: !titleDiscoverandOptimizePromptAvailable()" id="titleDiscoverandOptimizePrompt"  maxlength="2000" ></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form icon i-ai-1 e-lab" title="Test Prompt"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeTitle('both')} , disable: isAiAnalyzing() || !titleDiscoverandOptimizePromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetTitleDiscoverandOptimizePrompt ,disable: !titleDiscoverandOptimizePromptAvailable()" type="button"></button>
                            </div>

                        </div>

                        <div class="form-group row">
                            <!-- <label for="excerptSuggestionPrompt" class="form-label">Excerpt Prompt</label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: excerptSuggestionPromptAvailable" class="input-checkbox" id="excerptSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="excerptSuggestionPromptAvailable">Enable Excerpt Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: excerptSuggestionPrompt,disable: !excerptSuggestionPromptAvailable()" id="excerptSuggestionPrompt"  maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="excerpt-analysis-button" data-bind="click: function() { onClickAnalyzeExcerpt()} , disable: isAiAnalyzing() || !excerptSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetExcerptSuggestionPrompt, disable: !excerptSuggestionPromptAvailable()"></button>
                            </div>
                        </div>


                         <div class="form-group row">
                            <!-- <label for="seoSuggestionPrompt" class="form-label">SEO Fields (SEO Title & SEO Description) Prompt</label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: seoSuggestionPromptAvailable" class="input-checkbox" id="seoSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="seoSuggestionPromptAvailable">Enable SEO Fields (SEO Title & SEO Description) Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: seoSuggestionPrompt,disable: !seoSuggestionPromptAvailable()" id="seoSuggestionPrompt"  maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="seo-analysis-button" data-bind="click: function() { onClickAnalyzeSeo()} , disable: isAiAnalyzing() || !seoSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetSeoSuggestionPrompt, disable: !seoSuggestionPromptAvailable()"></button>
                            </div>
                        </div>

                        <div class="form-group row">
                            <!-- <label for="socialmediaSuggestionPrompt" class="form-label">Social Media Fields (SMO Title, SMO Description, & Social Tagline) Prompt</label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: socialmediaSuggestionPromptAvailable" class="input-checkbox" id="socialmediaSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="socialmediaSuggestionPromptAvailable">Enable Social Media Fields (SMO Title, SMO Description, & Social Tagline) Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: socialmediaSuggestionPrompt ,disable: !socialmediaSuggestionPromptAvailable()" id="socialmediaSuggestionPrompt"  maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="socialmedia-analysis-button" data-bind="click: function() { onClickAnalyzeSocialMedia()} , disable: isAiAnalyzing() || !socialmediaSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetSocialmediaSuggestionPrompt,disable: !socialmediaSuggestionPromptAvailable()"></button>
                            </div>
                        </div>
                            

                        <div class="form-group row">
                            <!-- <label for="threadSuggestionPrompt" class="form-label">Thread Fields (Thread Prompt & Thread Prompt Response) Prompt/label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: threadSuggestionPromptAvailable" class="input-checkbox" id="threadSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" title="refresh" for="threadSuggestionPromptAvailable">Enable Thread Fields (Thread Prompt & Thread Prompt Response) Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: threadSuggestionPrompt,disable: !threadSuggestionPromptAvailable()" id="threadSuggestionPrompt"  maxlength="2000" ></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="thread-analysis-button" data-bind="click: function() { onClickAnalyzeThread()} , disable: isAiAnalyzing() || !threadSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetThreadSuggestionPrompt,disable: !threadSuggestionPromptAvailable()"></button>
                            </div>
                        </div>



                           <strong class="form-sub-title parent">Content-Level Prompts</strong>





                        <div class="form-group row">

                            <div class="w-textarea">
                                <!-- <label for="factCheckSuggestionPrompt" class="form-label">Fact Check Prompt</label> -->
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: factCheckPromptAvailable" class="input-checkbox" id="factCheckPromptAvailable">
                                    <label class="form-label icon i-check" for="factCheckPromptAvailable">Enable Fact Check Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: factCheckSuggestionPrompt, disable: !factCheckPromptAvailable()" id="titleFactCheckSuggestionPrompt"  maxlength="2000" ></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form icon i-ai-1 e-lab" title="Test Prompt"  id="factcheck-analysis-button" data-bind="click: function() { onClickAnalyzeFactCheck()} , disable: isAiAnalyzing() || !factCheckPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetFactCheckSuggestionPrompt ,disable: !factCheckPromptAvailable()" type="button"></button>
                            </div>

                        </div>

                        <div class="form-group row">

                            <div class="w-textarea">
                                <!-- <label for="proofReadSuggestionPrompt" class="form-label">Fact Check Prompt</label> -->
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: proofReadPromptAvailable" class="input-checkbox" id="proofReadPromptAvailable">
                                    <label class="form-label icon i-check" for="proofReadPromptAvailable">Enable ProofRead Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: proofReadSuggestionPrompt, disable: !proofReadPromptAvailable()" id="titleProofReadSuggestionPrompt"  maxlength="2000" ></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form icon i-ai-1 e-lab" title="Test Prompt"  id="proofread-analysis-button" data-bind="click: function() { onClickAnalyzeProofread()} , disable: isAiAnalyzing() || !proofReadPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetProofReadSuggestionPrompt ,disable: !proofReadPromptAvailable()" type="button"></button>
                            </div>

                        </div>

                         <div class="form-group row">
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: widgetsSuggestionPromptAvailable" class="input-checkbox" id="widgetsSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="widgetsSuggestionPromptAvailable">Enable Widgets (quiz / poll assessment) Prompts</label>
                                </div>
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: widgetsSuggestionInterruptSaveEnabled, disable: !widgetsSuggestionPromptAvailable()" class="input-checkbox" id="widgetsSuggestionInterruptSaveEnabled">
                                    <label class="form-label icon i-check" for="widgetsSuggestionInterruptSaveEnabled">Interrupt completed/republish actions to prompt Widgets suggestions</label>
                                </div>
                                <textarea class="input-text" data-bind="value: widgetsSuggestionPrompt, disable: !widgetsSuggestionPromptAvailable()" id="widgetsSuggestionPrompt" maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="widgets-analysis-button" data-bind="click: function() { onClickAnalyzeWidgets()} , disable: isAiAnalyzing() || !widgetsSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetWidgetsSuggestionPrompts,disable: !widgetsSuggestionPromptAvailable()"></button>
                            </div>
                        </div>
                </div>

                <div class="w-form w-form-side ">

                    <div class="form-side-header-assistant">
                        <button id="btn-sidebar-hide" class="btn-sidebar hide icon i-dropdown-simple-b" type="button" data-bind="click: onClickToggleAssistant"></button>
                        <strong class="side-title icon i-ai-1">Assistant</strong>
                        <button id="btn-sidebar-expend" class="btn-sidebar expend icon i-expend" type="button" data-bind="click: onClickToggleAssistantExpand" ></button>
                        <!-- <button class="icon i-settings" type="button"></button> -->
                    </div>
                    <div class="form-body full-width cover w-title-analysis is-visible" id="title-analysis-window">
                        <div class="form-group w-chat-suggestions" data-bind="" id="title-analysis-content">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-footer">
            <button data-bind="event: {click: onClickCancelAiSettings}" class="btn" type="button">Cancel</button>
            <button data-bind="event: {click: onClickSaveAiSettings}" class="btn highlight" type="button">Save</button>
        </div>
    </div>

    `;


}



    protected buildViewModel(): any {
        let self = this;
        let viewModel =  {
            simpleSummaryPersonality: ko.observable(""),
            factualSummaryPersonality: ko.observable(""),
            satiricalSummaryPersonality: ko.observable(""),
            brandContext: ko.observable(""),
            emakiBrandContext: ko.observable(""),
            summaryPrompt: ko.observable(""),
            articleID: ko.observable(""),
            summaryAvailable: ko.observable(true),
            factualSummaryAvailable: ko.observable(true),
            satiricalSummaryAvailable: ko.observable(true),
            simpleSummaryAvailable: ko.observable(true),
            isSummaryOnByDefault: ko.observable(true),
            isThreadOnByDefault: ko.observable(true),
            isNewsletterPromotionOnByDefault: ko.observable(true),
            isListingPageNewsletterPromotionOnByDefault: ko.observable(true),
            isDealsCategoryPromotionOnByDefault: ko.observable(true),
            assistantFeatureFeedbackEnable: ko.observable(true),
            quizPrompt: ko.observable(""),
            pollPrompt: ko.observable(""),
            pollBrandContextAvailable: ko.observable(true),
            quizBrandContextAvailable: ko.observable(true),
            quizPersonality: ko.observable(""),
            pollPersonality: ko.observable(""),
            articlePollPersonality: ko.observable(""),
            articlePollBrandContextAvailable: ko.observable(false),
            articlePollPrompt: ko.observable(""),
            quizCTAPrompt: ko.observable(""),
            titleDiscoverandOptimizePrompt: ko.observable(""),
            seoSuggestionPromptAvailable: ko.observable(false),
            seoSuggestionPrompt: ko.observable(""),
            socialmediaSuggestionPromptAvailable: ko.observable(false),
            socialmediaSuggestionPrompt: ko.observable(""),
            widgetsSuggestionPromptAvailable: ko.observable(false),
            widgetsSuggestionInterruptSaveEnabled: ko.observable(false),
            widgetsSuggestionPrompt: ko.observable(""),
            threadSuggestionPromptAvailable: ko.observable(false),
            threadSuggestionPrompt: ko.observable(""),
            factCheckSuggestionPrompt: ko.observable(""),
            proofReadSuggestionPrompt: ko.observable(""),
            excerptSuggestionPromptAvailable: ko.observable(false),
            titleDiscoverandOptimizePromptAvailable: ko.observable(false),
            factCheckPromptAvailable: ko.observable(false),
            proofReadPromptAvailable: ko.observable(false),
            excerptSuggestionPrompt: ko.observable(""),
            selectedReferableBrands: ko.observableArray([]),
            selectedContentTypesSummary: ko.observableArray([]),
            selectedArticleTypesSummary: ko.observableArray([]),
            faqAvailable: ko.observable(false),
            faqBrandContextAvailable: ko.observable(true),
            faqPersonality: ko.observable(""),
            selectedfaqContentTypes: ko.observableArray([]),
            selectedfaqArticleTypes: ko.observableArray([]),
            faqPrompt: ko.observable(""),
            permissions: ko.observableArray(['config_assistant', 'config_assistant_general','config_assistant_website','config_assistant_emaki' ]),
            activeTab: ko.observable('general'),
            isAiAnalyzing: ko.observable(false),
            // **Thread**
            threadAvailable: ko.observable(false),
            threadPersonality: ko.observable(""),
            selectedThreadContentTypes: ko.observableArray([]),
            selectedThreadArticleTypes: ko.observableArray([]),
            threadPrompt: ko.observable(""),
            threadBrandContextAvailable: ko.observable(true),
            threadCTAPrompt: ko.observable(""),
            //newsletter promotion
            isNewsletterPromotionEnabled: ko.observable(false),
            // deals category promotion
            isDealsCategoryPromotionEnabled: ko.observable(false),
            selectedContentTypesNewsletterPromotion: ko.observableArray([]),
            selectedContentTypesDealsCategoryPromotion: ko.observableArray([]),
            selectedArticleTypesNewsletterPromotion: ko.observableArray([]),
            selectedArticleTypesDealsCategoryPromotion: ko.observableArray([]),
            newsletterPromotionPersonality: ko.observable(""),
            dealsCategoryPromotionPersonality: ko.observable(""),
            newsletterPromotionBrandContextAvailable: ko.observable(false),
            dealsCategoryPromotionBrandContextAvailable: ko.observable(false),
            //hubpage newsletter promotion
            newsletterPromotionPrompt: ko.observable(""),
            dealsCategoryPromotionPrompt: ko.observable(""),
            isListingPageNewsletterPromotionEnabled: ko.observable(false),
            selectedListingPageTypesNewsletterPromotion: ko.observableArray([]),
            listingPageNewsletterPromotionPersonality: ko.observable(""),
            listingPageNewsletterPromotionBrandContextAvailable: ko.observable(false),
            listingPageNewsletterPromotionPrompt: ko.observable(""),
            onDownloadFeedback: function (event) {
                self.onDownloadFeedback();
            },
            resetExcerptSuggestionPrompt: function (event) {
                self.resetExcerptSuggestionPrompt();
            },
            resetSeoSuggestionPrompt: function(event) {
                self.resetSeoSuggestionPrompt();
            },
            resetSocialmediaSuggestionPrompt: function(event) {
                self.resetSocialmediaSuggestionPrompt();
            },
            resetWidgetsSuggestionPrompts: function() {
                self.resetWidgetsSuggestionPrompts();
            },
            resetThreadSuggestionPrompt: function(event) {
                self.resetThreadSuggestionPrompt();
            },

            resetFactCheckSuggestionPrompt: function(event) {
                self.resetFactCheckSuggestionPrompt();
            },

            resetProofReadSuggestionPrompt: function(event) {
                self.resetProofReadSuggestionPrompt();
            },
            resetTitleDiscoverandOptimizePrompt: function(event) {
                self.resetTitleDiscoverandOptimizePrompt();
            },
            onClickAnalyzeTitle: function (data, event) {
                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeTitle(data);

                const settingsEl = document.getElementById("title-analysis-settings");
                if (!settingsEl) return;

                if (settingsEl.classList.contains("is-visible")) {
                    settingsEl.classList.remove("is-visible");

                     const settingsB = document.getElementById("title-analysis-settings-button");
                    if (!settingsB) return;
                    if (!settingsB.classList.contains("i-settings")) {
                        settingsB.classList.add("i-settings");
                    }
                    settingsB.classList.remove("i-recat-log");
                }




            },

            onClickAnalyzeSeo: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeSeo();



            },
            onClickAnalyzeSocialMedia: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeSocialMedia();

            },
            onClickAnalyzeWidgets: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeWidgets();

            },
            onClickAnalyzeThread: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeThread();

            },


            onClickAnalyzeExcerpt: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeExcerpt();



            },


              onClickAnalyzeProofread: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeProofread();
            },     onClickAnalyzeFactCheck: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeFactCheck();
            },

            onClickCancelAiSettings: function (data, event) {
                self.onClickCancelAiSettings();
            },
            onClickSaveAiSettings: function (data, param, event) {
                self.onClickSaveAiSettings();
            },
            onClickDeleteSelectedContentTypeSummary: function (data) {
                self.onClickDeleteSelectedContentTypeSummary(data);
            },
            onClickDeleteSelectedArticleTypeSummary: function (data) {
                self.onClickDeleteSelectedArticleTypeSummary(data);
            },
            onClickDeleteSelectedContentTypeFAQ: function (data) {
                self.onClickDeleteSelectedContentTypeFAQ(data);
            },
            onClickDeleteSelectedArticleTypeFAQ:function (data){
                self.onClickDeleteSelectedArticleTypeFAQ(data);
            },
            onClickDeleteSelectedContentTypeThread: function (data) {
                self.onClickDeleteSelectedContentTypeThread(data);
            },
            onClickDeleteSelectedArticleTypeThread: function (data) {
                self.onClickDeleteSelectedArticleTypeThread(data);
            },
            isNotDeletable: function () {
                return false;
            },
            onClickToggleAssistant: function (data, event) {
                const wFormArticle = document.querySelector(".w-form-article");
                if (wFormArticle.classList.contains("is-sidebar-closed")) {
                    wFormArticle.classList.remove("is-sidebar-closed");
                } else {
                    wFormArticle.classList.remove("is-sidebar-expanded");
                    wFormArticle.classList.add("is-sidebar-closed");
                }
            },
            onClickToggleAssistantExpand: function (data, event) {
                const wFormArticle = document.querySelector(".w-form-article");
                if (wFormArticle.classList.contains("is-sidebar-expanded")) {
                    wFormArticle.classList.remove("is-sidebar-expanded");
                } else {
                    wFormArticle.classList.add("is-sidebar-expanded");
                }
            },

        };
          ko.computed(function () {
                if (!viewModel.factualSummaryAvailable() &&
                    !viewModel.satiricalSummaryAvailable() &&
                    !viewModel.simpleSummaryAvailable()) {
                    viewModel.summaryAvailable(false);
                }else {
                    viewModel.summaryAvailable(true);
                }

        });


                return viewModel;

    }

    protected initPartial(): void {
        this.referableBrands = new multipleSelector_template("configai_referableBrandsFilter", this.getTemplateViewModel(), this.caller);
        this.referableBrands.setFilterContainerClass('margin-neg');
        this.referableBrands.setSelectAllEnabled(true);
        this.referableBrands.setSearchEnabled(true);
        this.referableBrands.setTagContainerId('selected_referableBrands');
        this.referableBrands.setTagContainerCaption('Selected Brands:');
        this.referableBrands.setLabel("Referable Brands");

        this.contentTypesForSummary = new multipleSelector_template("configai_contentTypeFilterSummary", this.getTemplateViewModel(), this.caller);
        this.contentTypesForSummary.setFilterContainerClass('margin-neg');
        this.contentTypesForSummary.setSelectAllEnabled(true);
        this.contentTypesForSummary.setSearchEnabled(true);
        this.contentTypesForSummary.setTagContainerId('selected_contentTypes_summary');
        this.contentTypesForSummary.setLabel("Content Types");

        this.contentTypesForFaq = new multipleSelector_template("configai_faqContentTypes", this.getTemplateViewModel(), this.caller);
        this.contentTypesForFaq.setFilterContainerClass('margin-neg');
        this.contentTypesForFaq.setSelectAllEnabled(true);
        this.contentTypesForFaq.setSearchEnabled(true);
        this.contentTypesForFaq.setTagContainerId('selected_faqContentTypes');
        this.contentTypesForFaq.setLabel("Content Types");

        this.articleTypesForFaq = new multipleSelector_template("configai_articleTypeFilterFaq", this.getTemplateViewModel(), this.caller);
        this.articleTypesForFaq.setFilterContainerClass('margin-neg');
        this.articleTypesForFaq.setSelectAllEnabled(true);
        this.articleTypesForFaq.setSearchEnabled(true);
        this.articleTypesForFaq.setTagContainerId('selected_articleTypes_faq');
        this.articleTypesForFaq.setLabel("Article Types");
        this.articleTypesForFaq.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.articleTypesForSummary = new multipleSelector_template("configai_articleTypeFilterSummary", this.getTemplateViewModel(), this.caller);
        this.articleTypesForSummary.setFilterContainerClass('margin-neg');
        this.articleTypesForSummary.setSelectAllEnabled(true);
        this.articleTypesForSummary.setSearchEnabled(true);
        this.articleTypesForSummary.setTagContainerId('selected_articleTypes_summary');
        this.articleTypesForSummary.setLabel("Article Types");
        this.articleTypesForSummary.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.filterDateForCsv = new filterDate_template("filterDateForCsv", this.getTemplateViewModel(), this.caller);
        this.filterDateForCsv.getTemplateViewModel().startDate(null);
        this.filterDateForCsv.getTemplateViewModel().endDate(null);
        this.filterDateForCsv.toggleClearButton(true);
        this.filterDateForCsv.setLabel('Date Feedback Created');
        this.filterDateForCsv.getTemplateViewModel().selectedFilter("range");
        this.filterDateForCsv.setRange("-30d", "0d");
        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.contentTypesForThread = new multipleSelector_template("configai_threadContentTypes", this.getTemplateViewModel(), this.caller);
        this.contentTypesForThread.setFilterContainerClass('margin-neg');
        this.contentTypesForThread.setSelectAllEnabled(true);
        this.contentTypesForThread.setSearchEnabled(true);
        this.contentTypesForThread.setTagContainerId('selected_threadContentTypes');
        this.contentTypesForThread.setLabel("Content Types");

        this.articleTypesForThread = new multipleSelector_template("configai_threadArticleTypeFilter", this.getTemplateViewModel(), this.caller);
        this.articleTypesForThread.setFilterContainerClass('margin-neg');
        this.articleTypesForThread.setSelectAllEnabled(true);
        this.articleTypesForThread.setSearchEnabled(true);
        this.articleTypesForThread.setTagContainerId('selected_threadArticleTypes');
        this.articleTypesForThread.setLabel("Article Types");
        this.articleTypesForThread.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.contentTypesForNewsletterPromotion = new multipleSelector_template("configai_contentTypeFilterNewsletter", this.getTemplateViewModel(), this.caller);
        this.contentTypesForNewsletterPromotion.setFilterContainerClass('margin-neg');
        this.contentTypesForNewsletterPromotion.setSelectAllEnabled(true);
        this.contentTypesForNewsletterPromotion.setSearchEnabled(true);
        this.contentTypesForNewsletterPromotion.setTagContainerId('selected_newsletterContentTypes');
        this.contentTypesForNewsletterPromotion.setLabel("Content Types");

        this.contentTypesForDealsCategoryPromotion = new multipleSelector_template("configai_contentTypeFilterDealsCategory", this.getTemplateViewModel(), this.caller);
        this.contentTypesForDealsCategoryPromotion.setFilterContainerClass('margin-neg');
        this.contentTypesForDealsCategoryPromotion.setSelectAllEnabled(true);
        this.contentTypesForDealsCategoryPromotion.setSearchEnabled(true);
        this.contentTypesForDealsCategoryPromotion.setTagContainerId('selected_dealsCategoryContentTypes');
        this.contentTypesForDealsCategoryPromotion.setLabel("Content Types");

        this.articleTypesForNewsletterPromotion = new multipleSelector_template("configai_articleTypeFilterNewsletter", this.getTemplateViewModel(), this.caller);
        this.articleTypesForNewsletterPromotion.setFilterContainerClass('margin-neg');
        this.articleTypesForNewsletterPromotion.setSelectAllEnabled(true);
        this.articleTypesForNewsletterPromotion.setSearchEnabled(true);
        this.articleTypesForNewsletterPromotion.setTagContainerId('selected_newsletterArticleTypes');
        this.articleTypesForNewsletterPromotion.setLabel("Article Types");
        this.articleTypesForNewsletterPromotion.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.articleTypesForDealsCategoryPromotion = new multipleSelector_template("configai_articleTypeFilterDealsCategory", this.getTemplateViewModel(), this.caller);
        this.articleTypesForDealsCategoryPromotion.setFilterContainerClass('margin-neg');
        this.articleTypesForDealsCategoryPromotion.setSelectAllEnabled(true);
        this.articleTypesForDealsCategoryPromotion.setSearchEnabled(true);
        this.articleTypesForDealsCategoryPromotion.setTagContainerId('selected_dealsCategoryArticleTypes');
        this.articleTypesForDealsCategoryPromotion.setLabel("Article Types");
        this.articleTypesForDealsCategoryPromotion.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.listingPageTypesForNewsletterPromotion = new multipleSelector_template("configai_listingPageTypesFilterNewsletter", this.getTemplateViewModel(), this.caller);
        this.listingPageTypesForNewsletterPromotion.setFilterContainerClass('margin-neg');
        this.listingPageTypesForNewsletterPromotion.setSelectAllEnabled(true);
        this.listingPageTypesForNewsletterPromotion.setSearchEnabled(true);
        this.listingPageTypesForNewsletterPromotion.setTagContainerId('selected_listingPageNewsletterHubpageTypes');
        this.listingPageTypesForNewsletterPromotion.setLabel("Hubpage Types");
        this.listingPageTypesForNewsletterPromotion.setItems([
            { id: 1, name: "List of Articles", value: 'articles' },
            { id: 2, name: "List of Tags", value: 'tags' },
            { id: 3, name: "Video Homepage", value: 'homepage_video' },
            { id: 4, name: "Thread Homepage", value: 'homepage_thread' },
            { id: 5, name: "Database HUB", value: 'tagHub' },
            { id: 6, name: "Mods", value: 'mods' }
        ]);

    }


    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticle.showDetails(true);
        this.getTemplateViewModel().filterArticle.articles(articles);
    }


    setContentTypeOptions(contentTypes) {
        this.contentTypesForSummary.setItems(contentTypes);
        this.contentTypesForFaq.setItems(contentTypes);
        this.contentTypesForThread.setItems(contentTypes);
        this.contentTypesForNewsletterPromotion.setItems(contentTypes);
        this.contentTypesForDealsCategoryPromotion.setItems(contentTypes);
    }

    onClickAnalyzeTitle(type){

        if(type == 'both'){
           this.addAiUserMessage('Generate title suggestions that are optimized based on performant similar articles and refined for relevance and performance.');

        }else if(type == 'ctr'){
              this.addAiUserMessage('Generate Title Suggestions using ctr Optimization');

        }else if(type == 'ctrNewModel'){
              this.addAiUserMessage('Generate Title Suggestions using the new summary embedding model');

        }else if(type == 'optimize'){
             this.addAiUserMessage('Generate Title Suggestions using Discover and Optimize ');

        }
       this.caller.analyzeArticleTitle(type);

    }
    public onClickAnalyzeImage(){
       this.addAiUserMessage('Provide a list of title and image combinations from performant similar articles.');
       this.caller.analyzeArticleByType('image');

    }

     public onClickAnalyzeSeo(){
       this.addAiUserMessage('Draft brief, search-optimized text to help the article stand out in search results.');
       this.caller.analyzeArticleByType('seo');

    }
     public onClickAnalyzeSocialMedia(){
       this.addAiUserMessage(' Create short, attention-grabbing text for sharing the article on social media.');
       this.caller.analyzeArticleByType('socialmedia');

    }
     public onClickAnalyzeWidgets(){
       this.addAiUserMessage("Evaluate the article to determine which widgets could enhance engagement or utility.");
       this.caller.analyzeArticleByType('widgets');

    }
     public onClickAnalyzeThread(){
       this.addAiUserMessage('  Produce Thread discussion prompts and a short response for each.');
       this.caller.analyzeArticleByType('thread');

    }
     public addAiUserMessage(message, type = 'preset') {
            const userMessageEl = document.createElement("div");
            if(type === 'customprompt') {
                    userMessageEl.id = "custom-prompts-content-userMessage";

            }else{
                   userMessageEl.id = "title-analysis-content-userMessage";

            }
            userMessageEl.classList.add("ai-userMessage");
            const messageLength = message.split(/<br>/).reduce((acc, curr) => acc + Math.ceil(curr.length / 40) * 40, 0);

           userMessageEl.innerHTML = `
            <div class="message-body truncated">
                ${message}
            </div>
            ${messageLength > 200 ? `<button class="read-more-btn">Show More</button>` : ''}

            `;

            // Append to container

            const articleSuggestionEl = document.getElementById("title-analysis-content");
            articleSuggestionEl.appendChild(userMessageEl);


            if (messageLength > 200) {
                // Toggle logic
                const messageBody = userMessageEl.querySelector(".message-body");
                const toggleBtn = userMessageEl.querySelector(".read-more-btn");

                toggleBtn.addEventListener("click", () => {
                    const isExpanded = !messageBody.classList.contains("truncated");

                    if (isExpanded) {
                        messageBody.classList.add("truncated");
                        toggleBtn.textContent = "Show More";
                    } else {
                        messageBody.classList.remove("truncated");
                        toggleBtn.textContent = "Hide";
                    }
                });
            }
          this.addAiBotThinking(type);
          this.scrollChatToBottom(false,type);
    }

    public addAiBotThinking(type = 'preset') {

        if(type === 'customprompt') {
            const articleSuggestionEl = document.getElementById("custom-prompts-content");
            const generatingCoverMessageEl = document.createElement("div");
            generatingCoverMessageEl.id = "custom-prompts-content-generating-cover";
            generatingCoverMessageEl.classList.add("ai-thinking");
            generatingCoverMessageEl.innerHTML = `
                                    <div class="loader-dot"></div>
                                `;
            articleSuggestionEl.appendChild(generatingCoverMessageEl);
        }else{
            const articleSuggestionEl = document.getElementById("title-analysis-content");
            const generatingCoverMessageEl = document.createElement("div");
            generatingCoverMessageEl.id = "title-analysis-content-generating-cover";
            generatingCoverMessageEl.classList.add("ai-thinking");
            generatingCoverMessageEl.innerHTML = `
                                        <div class="loader-dot"></div>
                                    `;
            articleSuggestionEl.appendChild(generatingCoverMessageEl);
        }

    }
    public scrollChatToBottom(Tobuttom = false ,type = 'preset') {
        let container;
        if(type === 'customprompt') {
            container = document.getElementById('custom-prompts-content');
        }else{
            container = document.getElementById('title-analysis-content');
        }
        const messages = container.querySelectorAll('.ai-userMessage');
        if(Tobuttom) {
            container.scrollTo({
                top: container.scrollHeight+100,
                behavior: 'smooth'
            });
            return
        }
        if (container && messages && messages.length > 0) {
            const lastMessage = messages[messages.length - 1] as HTMLElement;

            // Remove old spacer if it exists
            const existingSpacer = container.querySelector('.ai-scroll-spacer');
            if (existingSpacer) {
                existingSpacer.remove();
            }

            // Calculate dynamic height
            const containerHeight = container.clientHeight;
            const messageHeight = lastMessage.offsetHeight;
            const dynamicSpacerHeight = Math.max(0, containerHeight - messageHeight);

            // Create new spacer
            const spacer = document.createElement('div');
            spacer.className = 'ai-scroll-spacer';
            spacer.style.height = `${dynamicSpacerHeight}px`;
            spacer.style.opacity = '0';
            spacer.setAttribute('aria-hidden', 'true');

            // Insert spacer after the message
            container.appendChild( spacer);

            // Scroll so the message aligns to the top
            container.scrollTo({
                top: lastMessage.offsetTop,
                behavior: 'smooth'
            });
        }
    }

    public onDownloadFeedback() {
        let tvm = this.filterDateForCsv.getTemplateViewModel();
        let startDate =  tvm.startDate();
        let endDate = tvm.endDate();

        let data = {
            startDate: startDate ? `${startDate} 00:00:00`: '',
            endDate: endDate? `${endDate} 23:59:59`: ''
        };
        this.caller.downloadFeedbackCsv(data);
    }

    public onClickAnalyzeExcerpt(){
       this.addAiUserMessage('Suggest short excerpts to preview the article without giving too much away.');
       this.caller.analyzeArticleByType('excerpt');

    }


    public onClickAnalyzeProofread(){
       this.addAiUserMessage('Review the provided text for issues in spelling, grammar, punctuation, word choice, and overall clarity');
       this.caller.analyzeArticleByType('proofread');

    }  public onClickAnalyzeFactCheck(){
       this.addAiUserMessage('Review the provided text for issues in spelling, grammar, punctuation, word choice, and overall clarity');
       this.caller.analyzeArticleByType('factcheck');

    }

    public setSelectedFilterReferableBrands(brandsId): void {
        let selectedReferableBrands = [];
        this.referableBrands.getItems().forEach((c) => {
            if (brandsId.indexOf(c.id) !== -1) {
                selectedReferableBrands.push(c);
            }
        });
        this.getTemplateViewModel().selectedReferableBrands(selectedReferableBrands);
        this.referableBrands.setSelectedItems(selectedReferableBrands);
        this.referableBrands.setTags(brandsId, this.referableBrands.getItems());
    }

    public updateReferableBrands() {
        let selectedFilterReferableBrands = this.referableBrands.getSelectedItems();
        let referableBrands = this.referableBrands.getItems();

        let referableBrandList = [];
        for (let idReferableBrand of selectedFilterReferableBrands) {
            let referableBrand = referableBrands.find(c => c.id == idReferableBrand);
            if (referableBrand) {
                referableBrandList.push({
                    id: referableBrand.id,
                    name: referableBrand.name
                });
            }
        }

        let selectedReferableBrands = this.getTemplateViewModel().selectedReferableBrands();

        for (let ct of referableBrandList) {
            let existingReferableBrand = selectedReferableBrands.find(c => c.id == ct.id);
            if (!existingReferableBrand) {
                selectedReferableBrands.push(ct);
            }
        }

        for (let i = selectedReferableBrands.length - 1; i >= 0; i--) {
            let referableBrandToRemove = referableBrandList.find(c => c.id == selectedReferableBrands[i].id);
            if (!referableBrandToRemove) {
                selectedReferableBrands.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedReferableBrands([]);
        this.getTemplateViewModel().selectedReferableBrands(selectedReferableBrands);
    }
    public updateSelectedContentTypesThread(){
        let selectedFilterContentTypes = this.contentTypesForThread.getSelectedItems();
        let contentTypes = this.contentTypesForThread.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedThreadContentTypes();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedThreadContentTypes([]);
        this.getTemplateViewModel().selectedThreadContentTypes(selectedContentTypes);
    }

    public updateSelectedArticleTypesThread(){
        let selectedFilterArticleTypes = this.articleTypesForThread.getSelectedItems();
        let articleTypes = this.articleTypesForThread.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push(articleType);
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedThreadArticleTypes();

        for (let ct of articleTypeList) {
            let existingContentType = selectedArticleTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedArticleTypes.push(ct);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedThreadArticleTypes([]);
        this.getTemplateViewModel().selectedThreadArticleTypes(selectedArticleTypes);
    }

    protected onClickDeleteSelectedContentTypeThread(data){

        let allContentTypes = this.contentTypesForThread.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedThreadContentTypes();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedThreadContentTypes(selectedContentTypes);

        let selectedFilterContentTypes = this.contentTypesForThread.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {
            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.contentTypesForThread.setSelectedItems(updatedContentTypes);
    }

    protected onClickDeleteSelectedArticleTypeThread(data) {
        let allArticleTypes = this.articleTypesForThread.getItems();
        let selectedArticleTypes = this.getTemplateViewModel().selectedThreadArticleTypes();
        let index = selectedArticleTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedThreadArticleTypes(selectedArticleTypes);

        let selectedFilterArticleTypes = this.articleTypesForThread.getSelectedItems();

        index = selectedFilterArticleTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleTypes.splice(index, 1);
        }

        let updatedArticleTypes = [];
        for (let idType of selectedFilterArticleTypes) {
            let at = allArticleTypes.find(c => c.id == idType);
            if (at) {
                updatedArticleTypes.push(at);
            }
        }

        this.articleTypesForThread.setSelectedItems(updatedArticleTypes);
    }

    public updateSelectedContentTypesFAQ(){
        let selectedFilterContentTypes = this.contentTypesForFaq.getSelectedItems();
        let contentTypes = this.contentTypesForFaq.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedfaqContentTypes();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedfaqContentTypes([]);
        this.getTemplateViewModel().selectedfaqContentTypes(selectedContentTypes);
    }

    public updateSelectedArticleTypesFAQ(){

        let selectedFilterArticleTypes = this.articleTypesForFaq.getSelectedItems();
        let articleTypes = this.articleTypesForFaq.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push(articleType);
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedfaqArticleTypes();

        for (let ct of articleTypeList) {
            let existingContentType = selectedArticleTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedArticleTypes.push(ct);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedfaqArticleTypes([]);
        this.getTemplateViewModel().selectedfaqArticleTypes(selectedArticleTypes);
    }

    public setSelectedFilterContentTypesSummary(contentTypesId): void {
        let selectedContentTypes = [];
        this.contentTypesForSummary.getItems().forEach((c) => {
            if (contentTypesId.indexOf(c.id) !== -1) {
                selectedContentTypes.push(c);
            }
        });
        this.getTemplateViewModel().selectedContentTypesSummary(selectedContentTypes);
        this.contentTypesForSummary.setSelectedItems(selectedContentTypes);
    }

    public updateSelectedContentTypesSummary() {
        let selectedFilterContentTypes = this.contentTypesForSummary.getSelectedItems();
        let contentTypes = this.contentTypesForSummary.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypesSummary();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedContentTypesSummary([]);
        this.getTemplateViewModel().selectedContentTypesSummary(selectedContentTypes);
    }

    public setSelectedFilterArticleTypesSummary(articleTypesId): void {
        let selectedArticleTypes = [];
        this.articleTypesForSummary.getItems().forEach((c) => {
            if (articleTypesId.indexOf(c.id) !== -1) {
                selectedArticleTypes.push(c);
            }
        });
        this.getTemplateViewModel().selectedArticleTypesSummary(selectedArticleTypes);
        this.articleTypesForSummary.setSelectedItems(selectedArticleTypes);
    }

    public updateSelectedArticleTypesSummary() {
        let selectedFilterArticleTypes = this.articleTypesForSummary.getSelectedItems();
        let articleTypes = this.articleTypesForSummary.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push({
                id: articleType.id,
                name: articleType.name
            });
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypesSummary();

        for (let at of articleTypeList) {
            let existingArticleType = selectedArticleTypes.find(c => c.id == at.id);
            if (!existingArticleType) {
                selectedArticleTypes.push(at);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedArticleTypesSummary([]);
        this.getTemplateViewModel().selectedArticleTypesSummary(selectedArticleTypes);
    }

    protected onClickDeleteSelectedArticleTypeFAQ(data) {
        let allArticleTypes = this.articleTypesForFaq.getItems();
        let selectedArticleTypes = this.getTemplateViewModel().selectedfaqArticleTypes();
        let index = selectedArticleTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedfaqArticleTypes(selectedArticleTypes);

        let selectedFilterArticleTypes = this.articleTypesForFaq.getSelectedItems();

        index = selectedFilterArticleTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleTypes.splice(index, 1);
        }

        let updatedArticleTypes = [];
        for (let idType of selectedFilterArticleTypes) {
            let at = allArticleTypes.find(c => c.id == idType);
            if (at) {
                updatedArticleTypes.push(at);
            }
        }

        this.articleTypesForFaq.setSelectedItems(updatedArticleTypes);
    }

    protected onClickDeleteSelectedContentTypeSummary(data) {
        let allContentTypes = this.contentTypesForSummary.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypesSummary();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedContentTypesSummary(selectedContentTypes);

        let selectedFilterContentTypes = this.contentTypesForSummary.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {
            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.contentTypesForSummary.setSelectedItems(updatedContentTypes);
    }

    protected onClickDeleteSelectedArticleTypeSummary(data) {
        let allArticleTypes = this.articleTypesForSummary.getItems();
        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypesSummary();
        let index = selectedArticleTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedArticleTypesSummary(selectedArticleTypes);

        let selectedFilterArticleTypes = this.articleTypesForSummary.getSelectedItems();

        index = selectedFilterArticleTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleTypes.splice(index, 1);
        }

        let updatedArticleTypes = [];
        for (let idType of selectedFilterArticleTypes) {
            let at = allArticleTypes.find(c => c.id == idType);
            if (at) {
                updatedArticleTypes.push(at);
            }
        }

        this.articleTypesForSummary.setSelectedItems(updatedArticleTypes);
    }

    protected onClickDeleteSelectedContentTypeFAQ(data){

        let allContentTypes = this.contentTypesForFaq.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedfaqContentTypes();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedfaqContentTypes(selectedContentTypes);

        let selectedFilterContentTypes = this.contentTypesForFaq.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {
            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.contentTypesForFaq.setSelectedItems(updatedContentTypes);
    }

    protected getTemplateName(): string {
        return "config_ai_template";
    }

    public setPermissions(permissions) {
        this.getTemplateViewModel().permissions(permissions);
        this.getTemplateViewModel().activeTab((permissions['config_assistant_general'] && permissions['config_assistant_general'].write) ? 'general' : (permissions['config_assistant_website'] && permissions['config_assistant_website'].write) ? 'website' : 'emaki');
    }

    public getAiSettings() {

        this.caller.filterMultipleSelectorOnChange();

        let raw = {
            assistantFeatureFeedbackEnable: this.getTemplateViewModel().assistantFeatureFeedbackEnable(),
            simpleSummaryPersonality: this.getTemplateViewModel().simpleSummaryPersonality(),
            factualSummaryPersonality: this.getTemplateViewModel().factualSummaryPersonality(),
            satiricalSummaryPersonality: this.getTemplateViewModel().satiricalSummaryPersonality(),
            brandContext: this.getTemplateViewModel().brandContext(),
            emakiBrandContext: this.getTemplateViewModel().emakiBrandContext(),
            summaryPrompt: this.getTemplateViewModel().summaryPrompt(),
            articleID: this.getTemplateViewModel().articleID(),
            summaryAvailable: this.getTemplateViewModel().summaryAvailable(),
            factualSummaryAvailable: this.getTemplateViewModel().factualSummaryAvailable(),
            satiricalSummaryAvailable: this.getTemplateViewModel().satiricalSummaryAvailable(),
            simpleSummaryAvailable: this.getTemplateViewModel().simpleSummaryAvailable(),
            isSummaryOnByDefault: this.getTemplateViewModel().isSummaryOnByDefault(),
            isThreadOnByDefault: this.getTemplateViewModel().isThreadOnByDefault(),
            isNewsletterPromotionOnByDefault: this.getTemplateViewModel().isNewsletterPromotionOnByDefault(),
            isListingPageNewsletterPromotionOnByDefault: this.getTemplateViewModel().isListingPageNewsletterPromotionOnByDefault(),
            isDealsCategoryPromotionOnByDefault: this.getTemplateViewModel().isDealsCategoryPromotionOnByDefault(),
            quizPrompt: this.getTemplateViewModel().quizPrompt(),
            quizBrandContextAvailable: this.getTemplateViewModel().quizBrandContextAvailable(),
            quizPersonality: this.getTemplateViewModel().quizPersonality(),
            articlePollPersonality: this.getTemplateViewModel().articlePollPersonality(),
            articlePollBrandContextAvailable: this.getTemplateViewModel().articlePollBrandContextAvailable(),
            articlePollPrompt: this.getTemplateViewModel().articlePollPrompt(),
            selectedContentTypesSummary: this.getTemplateViewModel().selectedContentTypesSummary(),
            selectedArticleTypesSummary: this.getTemplateViewModel().selectedArticleTypesSummary(),
            titleDiscoverandOptimizePrompt: this.getTemplateViewModel().titleDiscoverandOptimizePrompt(),
            seoSuggestionPromptAvailable: this.getTemplateViewModel().seoSuggestionPromptAvailable(),
            seoSuggestionPrompt: this.getTemplateViewModel().seoSuggestionPrompt(),
            socialmediaSuggestionPromptAvailable: this.getTemplateViewModel().socialmediaSuggestionPromptAvailable(),
            socialmediaSuggestionPrompt: this.getTemplateViewModel().socialmediaSuggestionPrompt(),
            widgetsSuggestionPromptAvailable: this.getTemplateViewModel().widgetsSuggestionPromptAvailable(),
            widgetsSuggestionInterruptSaveEnabled: this.getTemplateViewModel().widgetsSuggestionInterruptSaveEnabled(),
            widgetsSuggestionPrompt: this.getTemplateViewModel().widgetsSuggestionPrompt(),
            threadSuggestionPromptAvailable: this.getTemplateViewModel().threadSuggestionPromptAvailable(),
            threadSuggestionPrompt: this.getTemplateViewModel().threadSuggestionPrompt(),
            excerptSuggestionPromptAvailable: this.getTemplateViewModel().excerptSuggestionPromptAvailable(),
            //FAQ
            selectedfaqContentTypes: this.getTemplateViewModel().selectedfaqContentTypes(),
            faqPrompt: this.getTemplateViewModel().faqPrompt(),
            selectedfaqArticleTypes: this.getTemplateViewModel().selectedfaqArticleTypes(),
            faqAvailable: this.getTemplateViewModel().faqAvailable(),
            faqBrandContextAvailable: this.getTemplateViewModel().faqBrandContextAvailable(),
            faqPersonality: this.getTemplateViewModel().faqPersonality(),
            titleDiscoverandOptimizePromptAvailable: this.getTemplateViewModel().titleDiscoverandOptimizePromptAvailable(),
            factCheckPromptAvailable: this.getTemplateViewModel().factCheckPromptAvailable(),
            factCheckSuggestionPrompt: this.getTemplateViewModel().factCheckSuggestionPrompt(),
            proofReadSuggestionPrompt : this.getTemplateViewModel().proofReadSuggestionPrompt(),
            proofReadPromptAvailable: this.getTemplateViewModel().proofReadPromptAvailable(),
            excerptSuggestionPrompt: this.getTemplateViewModel().excerptSuggestionPrompt(),
            //Thread
            threadPrompt: this.getTemplateViewModel().threadPrompt(),
            selectedThreadContentTypes: this.getTemplateViewModel().selectedThreadContentTypes(),
            selectedThreadArticleTypes: this.getTemplateViewModel().selectedThreadArticleTypes(),
            threadAvailable: this.getTemplateViewModel().threadAvailable(),
            threadPersonality: this.getTemplateViewModel().threadPersonality(),
            threadCTAPrompt: this.getTemplateViewModel().threadCTAPrompt(),
            selectedReferableBrands: this.getTemplateViewModel().selectedReferableBrands(),
            threadBrandContextAvailable: this.getTemplateViewModel().threadBrandContextAvailable(),
            //newsletter
            isNewsletterPromotionEnabled: this.getTemplateViewModel().isNewsletterPromotionEnabled(),
            isDealsCategoryPromotionEnabled: this.getTemplateViewModel().isDealsCategoryPromotionEnabled(),
            selectedContentTypesNewsletterPromotion: this.getTemplateViewModel().selectedContentTypesNewsletterPromotion(),
            selectedContentTypesDealsCategoryPromotion: this.getTemplateViewModel().selectedContentTypesDealsCategoryPromotion(),
            selectedArticleTypesNewsletterPromotion: this.getTemplateViewModel().selectedArticleTypesNewsletterPromotion(),
            selectedArticleTypesDealsCategoryPromotion: this.getTemplateViewModel().selectedArticleTypesDealsCategoryPromotion(),
            newsletterPromotionPersonality: this.getTemplateViewModel().newsletterPromotionPersonality(),
            dealsCategoryPromotionPersonality: this.getTemplateViewModel().dealsCategoryPromotionPersonality(),
            newsletterPromotionBrandContextAvailable: this.getTemplateViewModel().newsletterPromotionBrandContextAvailable(),
            dealsCategoryPromotionBrandContextAvailable: this.getTemplateViewModel().dealsCategoryPromotionBrandContextAvailable(),
            newsletterPromotionPrompt: this.getTemplateViewModel().newsletterPromotionPrompt(),
            dealsCategoryPromotionPrompt: this.getTemplateViewModel().dealsCategoryPromotionPrompt(),
            //hubpage newsletter
            isListingPageNewsletterPromotionEnabled: this.getTemplateViewModel().isListingPageNewsletterPromotionEnabled(),
            selectedListingPageTypesNewsletterPromotion: this.getTemplateViewModel().selectedListingPageTypesNewsletterPromotion(),
            listingPageNewsletterPromotionPersonality: this.getTemplateViewModel().listingPageNewsletterPromotionPersonality(),
            listingPageNewsletterPromotionBrandContextAvailable: this.getTemplateViewModel().listingPageNewsletterPromotionBrandContextAvailable(),
            listingPageNewsletterPromotionPrompt: this.getTemplateViewModel().listingPageNewsletterPromotionPrompt(),
        };


        let subViewModel = {
                assistantFeatureFeedbackEnable: raw.assistantFeatureFeedbackEnable,
                simpleSummaryPersonality: raw.simpleSummaryPersonality,
                factualSummaryPersonality: raw.factualSummaryPersonality,
                satiricalSummaryPersonality: raw.satiricalSummaryPersonality,
                brandContext: raw.brandContext,
                emakiBrandContext: raw.emakiBrandContext,
                summaryPrompt: raw.summaryPrompt,
                articleID: raw.articleID,
                summaryAvailable: raw.summaryAvailable,
                factualSummaryAvailable: raw.factualSummaryAvailable,
                satiricalSummaryAvailable: raw.satiricalSummaryAvailable,
                simpleSummaryAvailable: raw.simpleSummaryAvailable,
                isSummaryOnByDefault: raw.isSummaryOnByDefault,
                isThreadOnByDefault: raw.isThreadOnByDefault,
                isNewsletterPromotionOnByDefault: raw.isNewsletterPromotionOnByDefault,
                isListingPageNewsletterPromotionOnByDefault: raw.isListingPageNewsletterPromotionOnByDefault,
                isDealsCategoryPromotionOnByDefault: raw.isDealsCategoryPromotionOnByDefault,
                quizPrompt: raw.quizPrompt,
                quizBrandContextAvailable: raw.quizBrandContextAvailable,
                quizPersonality: raw.quizPersonality,
                articlePollPersonality: raw.articlePollPersonality,
                articlePollBrandContextAvailable: raw.articlePollBrandContextAvailable,
                articlePollPrompt: raw.articlePollPrompt,
                selectedContentTypesSummary: raw.selectedContentTypesSummary,
                selectedArticleTypesSummary: raw.selectedArticleTypesSummary,
                titleDiscoverandOptimizePrompt: raw.titleDiscoverandOptimizePrompt,
                seoSuggestionPromptAvailable: raw.seoSuggestionPromptAvailable,
                seoSuggestionPrompt: raw.seoSuggestionPrompt,
                socialmediaSuggestionPromptAvailable: raw.socialmediaSuggestionPromptAvailable,
                socialmediaSuggestionPrompt: raw.socialmediaSuggestionPrompt,
                widgetsSuggestionPromptAvailable: raw.widgetsSuggestionPromptAvailable,
                widgetsSuggestionInterruptSaveEnabled: raw.widgetsSuggestionInterruptSaveEnabled,
                widgetsSuggestionPrompt: raw.widgetsSuggestionPrompt,
                threadSuggestionPromptAvailable: raw.threadSuggestionPromptAvailable,
                threadSuggestionPrompt: raw.threadSuggestionPrompt,
                excerptSuggestionPromptAvailable: raw.excerptSuggestionPromptAvailable,
                //FAQ
                selectedfaqContentTypes: raw.selectedfaqContentTypes,
                faqPrompt: raw.faqPrompt,
                selectedfaqArticleTypes: raw.selectedfaqArticleTypes,
                faqAvailable: raw.faqAvailable,
                faqBrandContextAvailable: raw.faqBrandContextAvailable,
                faqPersonality: raw.faqPersonality,
                titleDiscoverandOptimizePromptAvailable: raw.titleDiscoverandOptimizePromptAvailable,
                factCheckPromptAvailable: raw.factCheckPromptAvailable,
                factCheckSuggestionPrompt: raw.factCheckSuggestionPrompt,
                proofReadSuggestionPrompt : raw.proofReadSuggestionPrompt,
                proofReadPromptAvailable: raw.proofReadPromptAvailable,
                excerptSuggestionPrompt: raw.excerptSuggestionPrompt,
                //Thread
                threadPrompt: raw.threadPrompt,
                selectedThreadContentTypes: raw.selectedThreadContentTypes,
                selectedThreadArticleTypes: raw.selectedThreadArticleTypes,
                threadAvailable: raw.threadAvailable,
                threadPersonality: raw.threadPersonality,
                threadCTAPrompt: raw.threadCTAPrompt,
                selectedReferableBrands: raw.selectedReferableBrands,
                threadBrandContextAvailable: raw.threadBrandContextAvailable,
                //Newsletter Promotion
                isNewsletterPromotionEnabled: raw.isNewsletterPromotionEnabled,
                isDealsCategoryPromotionEnabled: raw.isDealsCategoryPromotionEnabled,
                selectedContentTypesDealsCategoryPromotion: raw.selectedContentTypesDealsCategoryPromotion,
                selectedContentTypesNewsletterPromotion: raw.selectedContentTypesNewsletterPromotion,
                selectedArticleTypesNewsletterPromotion: raw.selectedArticleTypesNewsletterPromotion,
                selectedArticleTypesDealsCategoryPromotion: raw.selectedArticleTypesDealsCategoryPromotion,
                newsletterPromotionPersonality: raw.newsletterPromotionPersonality,
                dealsCategoryPromotionPersonality: raw.dealsCategoryPromotionPersonality,
                newsletterPromotionBrandContextAvailable: raw.newsletterPromotionBrandContextAvailable,
                dealsCategoryPromotionBrandContextAvailable: raw.dealsCategoryPromotionBrandContextAvailable,
                newsletterPromotionPrompt: raw.newsletterPromotionPrompt,
                dealsCategoryPromotionPrompt: raw.dealsCategoryPromotionPrompt,
                //Hubpage Newsletter Promotion
                isListingPageNewsletterPromotionEnabled: raw.isListingPageNewsletterPromotionEnabled,
                selectedListingPageTypesNewsletterPromotion: raw.selectedListingPageTypesNewsletterPromotion,
                listingPageNewsletterPromotionPersonality: raw.listingPageNewsletterPromotionPersonality,
                listingPageNewsletterPromotionBrandContextAvailable: raw.listingPageNewsletterPromotionBrandContextAvailable,
                listingPageNewsletterPromotionPrompt: raw.listingPageNewsletterPromotionPrompt
            };

        return subViewModel;
    }

    protected onClickSaveAiSettings(): any {
        this.caller.saveAiSettings();
    }

    protected onClickCancelAiSettings(): any {
        this.caller.cancelSiteSettings();
    }


    protected isConfigEnabled(value: any): boolean {
        if (value === true || value === 1) {
            return true;
        }
        if (typeof value === 'string') {
            return ['1', 'true', 'on', 'yes'].indexOf(value.toLowerCase()) !== -1;
        }
        return false;
    }

    public setAiSettings(data: any) {
        this.initialValues = data;
        this.getTemplateViewModel().assistantFeatureFeedbackEnable(data.assistantFeatureFeedbackEnable);
        this.getTemplateViewModel().simpleSummaryPersonality(data.simpleSummaryPersonality);
        this.getTemplateViewModel().factualSummaryPersonality(data.factualSummaryPersonality);
        this.getTemplateViewModel().satiricalSummaryPersonality(data.satiricalSummaryPersonality);
        this.getTemplateViewModel().brandContext(data.brandContext);
        this.getTemplateViewModel().emakiBrandContext(data.emakiBrandContext);
        this.getTemplateViewModel().summaryPrompt(data.summaryPrompt);
        this.getTemplateViewModel().articleID(data.articleID);
        this.getTemplateViewModel().summaryAvailable(data.summaryAvailable);
        this.getTemplateViewModel().factualSummaryAvailable(data.factualSummaryAvailable);
        this.getTemplateViewModel().satiricalSummaryAvailable(data.satiricalSummaryAvailable);
        this.getTemplateViewModel().simpleSummaryAvailable(data.simpleSummaryAvailable);
        this.getTemplateViewModel().isSummaryOnByDefault(data.isSummaryOnByDefault !== false);
        this.getTemplateViewModel().isThreadOnByDefault(data.isThreadOnByDefault !== false);
        this.getTemplateViewModel().isNewsletterPromotionOnByDefault(data.isNewsletterPromotionOnByDefault !== false);
        this.getTemplateViewModel().isListingPageNewsletterPromotionOnByDefault(data.isListingPageNewsletterPromotionOnByDefault !== false);
        this.getTemplateViewModel().isDealsCategoryPromotionOnByDefault(data.isDealsCategoryPromotionOnByDefault !== false);
        this.getTemplateViewModel().quizPrompt(data.quizPrompt);
        this.getTemplateViewModel().quizBrandContextAvailable(data.quizBrandContextAvailable);
        this.getTemplateViewModel().titleDiscoverandOptimizePrompt(data.titleDiscoverandOptimizePrompt);
        this.getTemplateViewModel().seoSuggestionPromptAvailable(data.seoSuggestionPromptAvailable);
        this.getTemplateViewModel().seoSuggestionPrompt(data.seoSuggestionPrompt);
        this.getTemplateViewModel().socialmediaSuggestionPromptAvailable(data.socialmediaSuggestionPromptAvailable);
        this.getTemplateViewModel().socialmediaSuggestionPrompt(data.socialmediaSuggestionPrompt);
        this.getTemplateViewModel().widgetsSuggestionPromptAvailable(data.widgetsSuggestionPromptAvailable);
        this.getTemplateViewModel().widgetsSuggestionInterruptSaveEnabled(data.widgetsSuggestionInterruptSaveEnabled);
        this.getTemplateViewModel().widgetsSuggestionPrompt(data.widgetsSuggestionPrompt);
        this.getTemplateViewModel().threadSuggestionPromptAvailable(data.threadSuggestionPromptAvailable);
        this.getTemplateViewModel().threadSuggestionPrompt(data.threadSuggestionPrompt);
        this.getTemplateViewModel().threadBrandContextAvailable(data.threadBrandContextAvailable);
        this.getTemplateViewModel().excerptSuggestionPromptAvailable(data.excerptSuggestionPromptAvailable);
        this.getTemplateViewModel().titleDiscoverandOptimizePromptAvailable(data.titleDiscoverandOptimizePromptAvailable);
        this.getTemplateViewModel().factCheckPromptAvailable(data.factCheckPromptAvailable);
        this.getTemplateViewModel().factCheckSuggestionPrompt(data.factCheckSuggestionPrompt);
        this.getTemplateViewModel().proofReadSuggestionPrompt(data.proofReadSuggestionPrompt);
        this.getTemplateViewModel().proofReadPromptAvailable(data.proofReadPromptAvailable);
        this.getTemplateViewModel().excerptSuggestionPrompt(data.excerptSuggestionPrompt);
        this.getTemplateViewModel().quizPersonality(data.quizPersonality);
        this.getTemplateViewModel().articlePollPersonality(data.articlePollPersonality || "");
        this.getTemplateViewModel().articlePollBrandContextAvailable(this.isConfigEnabled(data.articlePollBrandContextAvailable));
        this.getTemplateViewModel().articlePollPrompt(data.articlePollPrompt || `INSTRUCTIONS:\n- Create an engaging 3-question poll for readers who finished reading the article.\n- Use the article to identify the main topic and areas of reader interest.\n- Do not ask readers to recall article details or identify a factually correct answer.\n- Ask about the reader’s opinion, preference, experience, or future intent.\n- Avoid questions that cannot be answered honestly by a meaningful portion of the article's audience.\n- When it fits naturally, favor a question whose responses could provide commercially useful audience insights.`);
        this.getTemplateViewModel().selectedContentTypesSummary(data.selectedContentTypesSummary || []);
        this.contentTypesForSummary.setSelectedItems(data.selectedContentTypesSummary || []);
        this.getTemplateViewModel().selectedArticleTypesSummary(data.selectedArticleTypesSummary || []);
        this.articleTypesForSummary.setSelectedItems(data.selectedArticleTypesSummary || []);
        //FAQ
        this.getTemplateViewModel().selectedfaqContentTypes(data.selectedfaqContentTypes || []);
        this.contentTypesForFaq.setSelectedItems(data.selectedfaqContentTypes || []);
        this.getTemplateViewModel().selectedfaqArticleTypes(data.selectedfaqArticleTypes || []);
        this.articleTypesForFaq.setSelectedItems(data.selectedfaqArticleTypes || []);
        this.getTemplateViewModel().selectedReferableBrands(data.selectedReferableBrands || []);
        this.referableBrands.setSelectedItems(data.selectedReferableBrands || []);
        this.referableBrands.setTags(data.selectedReferableBrands ? data.selectedReferableBrands.map(b => b.id) : [], this.referableBrands.getItems());
        this.getTemplateViewModel().faqAvailable(data.faqAvailable || false);
        this.getTemplateViewModel().faqBrandContextAvailable(data.faqBrandContextAvailable);
        this.getTemplateViewModel().faqPersonality(data.faqPersonality || "");
        this.getTemplateViewModel().faqPrompt(data.faqPrompt || "");
        //Thread
        this.getTemplateViewModel().selectedThreadContentTypes(data.selectedThreadContentTypes || []);
        this.contentTypesForThread.setSelectedItems(data.selectedThreadContentTypes || []);
        this.getTemplateViewModel().selectedThreadArticleTypes(data.selectedThreadArticleTypes || []);
        this.articleTypesForThread.setSelectedItems(data.selectedThreadArticleTypes || []);
        this.getTemplateViewModel().threadAvailable(data.threadAvailable || false);
        this.getTemplateViewModel().threadPersonality(data.threadPersonality || "");
        this.getTemplateViewModel().threadPrompt(data.threadPrompt || "");
        this.getTemplateViewModel().threadCTAPrompt(data.threadCTAPrompt || "");
        //Newsletter
        this.getTemplateViewModel().isNewsletterPromotionEnabled(data.isNewsletterPromotionEnabled || false);
        this.getTemplateViewModel().isDealsCategoryPromotionEnabled(data.isDealsCategoryPromotionEnabled || false);
        this.contentTypesForNewsletterPromotion.setSelectedItems(data.selectedContentTypesNewsletterPromotion || []);
        this.contentTypesForDealsCategoryPromotion.setSelectedItems(data.selectedContentTypesDealsCategoryPromotion || []);
        this.articleTypesForNewsletterPromotion.setSelectedItems(data.selectedArticleTypesNewsletterPromotion || []);
        this.articleTypesForDealsCategoryPromotion.setSelectedItems(data.selectedArticleTypesDealsCategoryPromotion || []);
        this.getTemplateViewModel().newsletterPromotionPersonality(data.newsletterPromotionPersonality || "");
        this.getTemplateViewModel().dealsCategoryPromotionPersonality(data.dealsCategoryPromotionPersonality || "");
        this.getTemplateViewModel().newsletterPromotionBrandContextAvailable(data.newsletterPromotionBrandContextAvailable || false);
        this.getTemplateViewModel().dealsCategoryPromotionBrandContextAvailable(data.dealsCategoryPromotionBrandContextAvailable || false);
        this.getTemplateViewModel().newsletterPromotionPrompt(data.newsletterPromotionPrompt || "");
        this.getTemplateViewModel().dealsCategoryPromotionPrompt(data.dealsCategoryPromotionPrompt || "");
        //hubpage newsletter
        this.getTemplateViewModel().isListingPageNewsletterPromotionEnabled(data.isListingPageNewsletterPromotionEnabled || false);
        this.listingPageTypesForNewsletterPromotion.setSelectedItems(data.selectedListingPageTypesNewsletterPromotion || []);
        this.getTemplateViewModel().listingPageNewsletterPromotionPersonality(data.listingPageNewsletterPromotionPersonality || "");
        this.getTemplateViewModel().listingPageNewsletterPromotionBrandContextAvailable(data.listingPageNewsletterPromotionBrandContextAvailable || false);
        this.getTemplateViewModel().listingPageNewsletterPromotionPrompt(data.listingPageNewsletterPromotionPrompt || "");
    }

    public resetTitleDiscoverandOptimizePrompt(): void {
        this.getTemplateViewModel().titleDiscoverandOptimizePrompt(this.initialValues.titleDiscoverandOptimizePrompt);
    }
      public resetFactCheckSuggestionPrompt(): void {
        this.getTemplateViewModel().factCheckSuggestionPrompt(this.initialValues.factCheckSuggestionPrompt);
    }
      public resetProofReadSuggestionPrompt(): void {
        this.getTemplateViewModel().proofReadSuggestionPrompt(this.initialValues.proofReadSuggestionPrompt);
    }

       public resetThreadSuggestionPrompt(): void {
        this.getTemplateViewModel().threadSuggestionPrompt(this.initialValues.threadSuggestionPrompt);
    }

    public resetSeoSuggestionPrompt(): void {
        this.getTemplateViewModel().seoSuggestionPrompt(this.initialValues.seoSuggestionPrompt);
    }

    public resetSocialmediaSuggestionPrompt(): void {
        this.getTemplateViewModel().socialmediaSuggestionPrompt(this.initialValues.socialmediaSuggestionPrompt);
    }

    public resetWidgetsSuggestionPrompts(): void {
        this.getTemplateViewModel().widgetsSuggestionPrompt(this.initialValues.widgetsSuggestionPrompt);
    }

    public resetExcerptSuggestionPrompt(): void {
        this.getTemplateViewModel().excerptSuggestionPrompt(this.initialValues.excerptSuggestionPrompt);
    }

    public buildDatePickerCalendar() : void {
        this.filterDateForCsv.buildCalendar();
    }

    public updateSelectedContentTypesNewsletterPromotion() {
        let selectedFilterContentTypes = this.contentTypesForNewsletterPromotion.getSelectedItems();
        let contentTypes = this.contentTypesForNewsletterPromotion.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypesNewsletterPromotion();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedContentTypesNewsletterPromotion([]);
        this.getTemplateViewModel().selectedContentTypesNewsletterPromotion(selectedContentTypes);
    }

    public updateSelectedContentTypesDealsCategoryPromotion() {
        let selectedFilterContentTypes = this.contentTypesForDealsCategoryPromotion.getSelectedItems();
        let contentTypes = this.contentTypesForDealsCategoryPromotion.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypesDealsCategoryPromotion();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedContentTypesDealsCategoryPromotion([]);
        this.getTemplateViewModel().selectedContentTypesDealsCategoryPromotion(selectedContentTypes);
    }

    public updateSelectedArticleTypesNewsletterPromotion() {
        let selectedFilterArticleTypes = this.articleTypesForNewsletterPromotion.getSelectedItems();
        let articleTypes = this.articleTypesForNewsletterPromotion.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push({
                id: articleType.id,
                name: articleType.name
            });
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypesNewsletterPromotion();

        for (let at of articleTypeList) {
            let existingArticleType = selectedArticleTypes.find(c => c.id == at.id);
            if (!existingArticleType) {
                selectedArticleTypes.push(at);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedArticleTypesNewsletterPromotion([]);
        this.getTemplateViewModel().selectedArticleTypesNewsletterPromotion(selectedArticleTypes);
    }

    public updateSelectedArticleTypesDealsCategoryPromotion() {
        let selectedFilterArticleTypes = this.articleTypesForDealsCategoryPromotion.getSelectedItems();
        let articleTypes = this.articleTypesForDealsCategoryPromotion.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push({
                    id: articleType.id,
                    name: articleType.name
                });
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypesDealsCategoryPromotion();

        for (let at of articleTypeList) {
            let existingArticleType = selectedArticleTypes.find(c => c.id == at.id);
            if (!existingArticleType) {
                selectedArticleTypes.push(at);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedArticleTypesDealsCategoryPromotion([]);
        this.getTemplateViewModel().selectedArticleTypesDealsCategoryPromotion(selectedArticleTypes);
    }

    public updateSelectedListingPageTypesNewsletterPromotion() {
        let selectedFilterArticleTypes = this.listingPageTypesForNewsletterPromotion.getSelectedItems();
        let articleTypes = this.listingPageTypesForNewsletterPromotion.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push({
                id: articleType.id,
                name: articleType.name,
                value: articleType.value
            });
            }
        }

        let selectedHubpageTypes = this.getTemplateViewModel().selectedListingPageTypesNewsletterPromotion();

        for (let at of articleTypeList) {
            let existingArticleType = selectedHubpageTypes.find(c => c.id == at.id);
            if (!existingArticleType) {
                selectedHubpageTypes.push(at);
            }
        }

        for (let i = selectedHubpageTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedHubpageTypes[i].id);
            if (!articleTypeToRemove) {
                selectedHubpageTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedListingPageTypesNewsletterPromotion([]);
        this.getTemplateViewModel().selectedListingPageTypesNewsletterPromotion(selectedHubpageTypes);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/config_ai_template.ts